import { $set, update } from 'qim';

import { createReducer } from '@zapier/toolbox-redux-framework';

import ActionTypes from 'app/homepage/ActionTypes';

const initialState = {
  serviceSearch: {
    query: '',
    selectedService: undefined,
  },
};

const handlers = {
  // SERVICE SEARCH
  [ActionTypes.CHANGE_APP_SEARCH_QUERY](state, action) {
    return update(['serviceSearch', 'query', $set(action.query)], state);
  },

  [ActionTypes.SELECT_SERVICE_SEARCH_SERVICE](state, action) {
    return update(
      ['serviceSearch', 'selectedService', $set(action.service)],
      state
    );
  },
};

export default createReducer(handlers, initialState);
